export const toggleNav = () => {
  const btnToggleNav = '.js-toggle-nav';
  const $body = $('body');
  const $overlayNav = $('.js-overlay-nav');

  let isNavToggled = false;

  const init = () => {
    bind();
  };

  const bind = () => {
    $body.on('click', btnToggleNav, (e) => {
      e.preventDefault();
      toggle();
    });
  };

  const toggle = () => {

    if (isNavToggled) {
      $overlayNav.removeClass('is-active');
      $body.attr('data-menu-open','false');
    } else {
      $overlayNav.addClass('is-active');
      $body.attr('data-menu-open','true');
    }

    isNavToggled = !isNavToggled;

  };

  init();

};
